import React from 'react';
import Button, { ButtonProps } from './Button';

export interface IconButtonProps extends Omit<ButtonProps, 'aria-label'> {
  label: string;
  children: React.ReactNode;
}

const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(({
  label,
  radius = 'circle',
  children,
  ...props
}, ref) => (
  <Button ref={ref} aria-label={label} radius={radius} {...props}>
    {children}
  </Button>
));

IconButton.displayName = 'IconButton';

export default IconButton;

